import './ErrorCard.css'

export default function ErrorCard({ title, text, code, onRetry, onSkip, onHelp }) {
  return (
    <div className="error-card">
      <div className="error-card-header">
        <span className="error-card-icon">⚠</span>
        <span className="error-card-title">{title}</span>
      </div>
      {text && <div className="error-card-text">{text}</div>}
      {code && <div className="error-card-code">{code}</div>}
      <div className="error-card-actions">
        {onRetry && <button className="error-btn retry" onClick={onRetry}>Retry Step</button>}
        {onSkip && <button className="error-btn skip" onClick={onSkip}>Skip &amp; Continue</button>}
        {onHelp && <button className="error-btn help" onClick={onHelp}>Upload missing data</button>}
      </div>
    </div>
  )
}
